import { endOfDay } from 'date-fns';

import { queryClient, useMutation } from '../../../ReactQuery';
import { put } from '../../../redux/api';
import type { Banner, DeactivateBannerRequest, GetBannersResponse } from '../../../../shared/types/routes/banners';

import { invalidateActiveBanners } from './useActiveBanners';
import { bannersQueryKey } from './useBanners';

const createDeactivateRequestBody = (): DeactivateBannerRequest => ({
  endDate: endOfDay(new Date()).toISOString(),
});

const deactivateBanner = (id: number) =>
  put<DeactivateBannerRequest, Banner>(`/api/banners/${id}/deactivate`, createDeactivateRequestBody());

/**
 * Hook for deactivating a banner by setting its end date to the end of the current day.
 */
export default function useDeactivateBanner() {
  return useMutation<number, Response & { data?: Banner }>({
    mutationFn: deactivateBanner,
    onSuccess: (_response, id: number) => {
      //  Update the banners query cache
      queryClient.setQueryData<GetBannersResponse>(bannersQueryKey, (banners?: GetBannersResponse) => {
        return (banners ? banners.map((banner) => banner.id !== id ? banner : ({
          ...banner,
          isDeactivated: true,
          endDate: endOfDay(new Date()).toISOString(),
        })) : []) as GetBannersResponse;
      });
      invalidateActiveBanners();
    },
  });
}
